import { useState } from "react";

import { Checkbox } from "@newsela/angelou";
import PropTypes from "prop-types";

import { actionNames, objectTypes, withTrackEvent } from "@newsela/snitch";
import { checkBoxLabelCss } from "./LanguageSetting.style";

const CheckboxWithTrackEvent = withTrackEvent(Checkbox);

const propTypes = {
  assignmentId: PropTypes.string,
  currentContentLevel: PropTypes.object,
  isLanguageSelectorHidden: PropTypes.bool,
  onHideLanguageSelectorChange: PropTypes.func,
};

const LanguageSetting = ({
  assignmentId,
  currentContentLevel,
  isLanguageSelectorHidden,
  onHideLanguageSelectorChange,
}) => {
  const [isHideLanguageChecked, setIsHideLanguageChecked] = useState(
    !isLanguageSelectorHidden,
  );

  const eventProperties = {
    objectType: objectTypes.assignment,
    actionName: actionNames.update,
    streamProperties: {
      content_type: "Article",
      content_id: currentContentLevel?.id,
      content_ids: [currentContentLevel?.header_id],
      description: `Toggle students can change article's language ${isLanguageSelectorHidden ? "on" : "off"}`,
      object_id: assignmentId,
    },
  };

  return (
    <CheckboxWithTrackEvent
      __cssFor={{ root: checkBoxLabelCss(isHideLanguageChecked) }}
      checked={isHideLanguageChecked}
      label={"Students can change the entire article's language"}
      name={"Students can change the entire article's language"}
      dataProps={{
        "data-qa-selector": `students_can_change_article_language_${isLanguageSelectorHidden ? "on" : "off"}`,
      }}
      onClick={() => {
        setIsHideLanguageChecked(
          (prevIsHideLanguageChecked) => !prevIsHideLanguageChecked,
        );
        onHideLanguageSelectorChange(!isLanguageSelectorHidden);
      }}
      {...eventProperties}
    />
  );
};

LanguageSetting.propTypes = propTypes;

export default LanguageSetting;
